import { render } from "./TableViewNew.vue?vue&type=template&id=3fe2aea1"
import script from "./TableViewNew.vue?vue&type=script&lang=js"
export * from "./TableViewNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__